module.exports = __webpack_public_path__ + "img/flex_service.16e5ffe.webp";